module.exports = __webpack_public_path__ + "img/4708c6c.png";